import { getHttp, lazySingleton } from "../_common/common";

export class MyAccountBannersService {
  async getActiveBanners() {
    const baseUrl = micuentaenv.SHOP_URL[1]
      .replace("://ilerna.es", "://www.ilerna.es")
      .replace(/\/$/, "");
    const response = await getHttp(`${baseUrl}/WsExternal/mi_cuenta_banner.php`, { credentials: "omit" });

    return Object.values(response.data || {}).filter(Boolean);
  }
}

export const svcMyAccountBanners = lazySingleton(() => new MyAccountBannersService());
